import React from 'react';
import './product-offers-title.scss';

interface ProductOffersTitleProps {
    productName: string;
    description: string;
    isLarge?: boolean;
}

const ProductOffersTitle: React.FC<ProductOffersTitleProps> = ({ productName, description, children, isLarge }) => (
    <h2 className="product-offers-title">
        <span className={`product-offers-title__name${isLarge ? ' product-offers-title__name--large' : ''}`}>
            {productName}
        </span>
        <span className="product-offers-title__description">
            {`${description}`}
            {children}
        </span>
    </h2>
);

export default ProductOffersTitle;
